import React from 'react';
import Layout from '../components/layout';
import Hero from '../components/hero';

import '../styles/about.css';


export default () => {
    return (
        <Layout active='about'>
            <Hero title="About Us" subtitle="We are big city peeps with small town values"/>
            <div className="blurb">
            <div>
                <p>With differing industries come differing software needs. Sure some solutions could be hacked to work together, but we prefer to get it done correctly.</p>
                <p>We have experience in multiple industries including banking, professional sports, food distribution and education. These experiences have allowed us to create tailored software solutions for the issue at hand. We only use cookie cutters in the kitchen.</p>
            </div>
            <div>
                <p>We are a small company but we leverage modern technologies to allow us to do big things! We can get projects moving quickly and dedicate our full attention to our client base.</p>
            </div>
        </div>
        <div className="about-stats">
            <h2>Company Details</h2>
            <p>Founded: 2021</p>
            <p>Headquarters: Marion, Texas</p>
        </div>
        {/* <div className="light-section">
            <h2>@ricardoa</h2>
        </div> */}
        </Layout>
    )
}